module.exports = __webpack_public_path__ + "static/media/morning-sleep.dbdf19d1.svg";